<template>
  <PmNotificationLeaveRequestAcceptedPure
    v-bind="{ ...$attrs, ...props }"
    @open-details="isDetailsVisible = true"
  />

  <portal to="modal">
    <PmModalPure
      v-if="isDetailsVisible"
      title="Urlaubsantrag"
      @close="isDetailsVisible = false"
    >
      <PmRequestDetail
        v-if="isDetailsVisible"
        :id="props.leaveRequestId"
        type="leaveRequest"
      />
    </PmModalPure>
  </portal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import PmNotificationLeaveRequestAcceptedPure, {
  type Props as PropsNotificationLeaveRequestCreatedPure,
} from '@/components/PmNotification/PmNotificationLeaveRequestAccepted/PmNotificationLeaveRequestAcceptedPure.vue'
import PmRequestDetail from '@/components/PmRequestDetail/PmRequestDetail.vue'
import PmModalPure from '@/components/basics/PmModalPure.vue'

export type Props = PropsNotificationLeaveRequestCreatedPure

const props = withDefaults(defineProps<Props>(), {})

const isDetailsVisible = ref(false)
</script>
